import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import useTailwindBrand from '../Theme/useTailwindBrand';

const MessageDialog: React.FC = () => {
  const { common } = useTailwindBrand();
  const MySwal = useMemo(() => withReactContent(Swal), []);
  const generalMessage = useSelector((state: any) => state.message);
  const dispatch = useDispatch();

  const hideMessage = useCallback(() => { dispatch({ type: 'HIDE_MESSAGE', payload: '' }); }, [dispatch]);

  const getTitle = useCallback((type: SweetAlertIcon | string, customTitle?: string): string => {
    if (customTitle) return customTitle;

    switch (type) {
      case 'error':
        return 'Une erreur est survenue';
      case 'warning':
        return 'Remarque';
      case 'success':
        return '';
      default:
        return '';
    }
  }, []);

  const displayMessage = useCallback(
    (type: SweetAlertIcon | string, message: string, customTitle?: string) => {
      // Ignorer les messages d'erreur d'authentification et les messages cachés
      if (type === 'error_auth' || !type || type === 'HIDE_MESSAGE') {
        return;
      }

      const title = getTitle(type, customTitle);

      // Message multi-lignes (liste d'erreurs) : on aligne à gauche ; sinon centré (comportement existant).
      const isMultiline = typeof message === 'string' && message.includes('\n');

      setTimeout(() => {
        MySwal.fire({
          icon: type as SweetAlertIcon,
          title: <div className={common.subtitle2}>{title}</div>,
          html: <div className={common.body} style={{ whiteSpace: 'pre-line', textAlign: isMultiline ? 'left' : 'center' }}>{message}</div>,
          timer: 6000,
          showConfirmButton: false,
          willClose: hideMessage,
        });
      }, 0);
    },
    [MySwal, common.subtitle2, common.body, getTitle, hideMessage]
  );

  useEffect(() => {
    if (generalMessage.type && generalMessage.message) {
      displayMessage(generalMessage.type, generalMessage.message);
    }
  }, [generalMessage.type, generalMessage.message, displayMessage]);

  return null;
};

export default MessageDialog;
